<div class="item" fxLayout.lt-mv="row" fxLayoutAlign="space-between" ngClass.lt-mv="mobile">
  <span class="item-label" fxFlex="80%">{{ label }}</span>
  <span ngClass.lt-mv="mobile" class="item-value" fxLayoutAlign="end end">{{ value | lT }} </span>
</div>
<nz-divider></nz-divider>
